export const getGAEventName = (eventName?: string) =>{
  if (!eventName) return ''
  return `ga-${eventName}`
}